import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { usePinInput } from 'react-pin-input-hook';
import { useCustomNavigate } from '../../../hooks/useCustomNavigate';
import { ROUTES } from '../../../types/routes';
import { CustomButton } from '../../common/buttons/index';
import { PinInput } from '../../common/inputs/index';
import {
	useAskNewEmailCodeMutation,
	useSubmitEmailCodeMutation
} from '../../../data/mutations/registration';

const RegistrationEmailCodeLayout = () => {
	const { t } = useTranslation();
	const navigate = useCustomNavigate();

	const [fakeError, setFakeError] = useState<boolean>(false);

	const [values, setValues] = useState<string[]>(
		Number(sessionStorage.getItem('inputLength')) === 6
			? ['', '', '', '', '', '']
			: ['', '', '', '']
	);
	const { fields } = usePinInput({
		values,
		onChange: (values: string[]) => {
			setFakeError(false);
			setValues(values);
		},
		onComplete: (value: string) => {
			if (
				value.length === Number(sessionStorage.getItem('inputLength'))
			) {
				mutateAsync({ code: value });
			}
		},
		type: 'numeric',
		placeholder: ''
	});

	const [isResendCodeActive, setIsResendCodeActive] =
		useState<boolean>(false);
	const [counter, setCounter] = useState<number>(
		Number(sessionStorage.getItem('resendIn'))
	);

	const { askNewCode } = useAskNewEmailCodeMutation();
	const { isError, mutateAsync, mutationError, isPending } =
		useSubmitEmailCodeMutation(navigate);

	const handleResendCode = async () => {
		askNewCode();
		setIsResendCodeActive(false);
		setCounter(Number(sessionStorage.getItem('resendIn')));
	};

	const handleBackClick = () => {
		navigate(ROUTES.REGISTRATION.INDEX);
	};

	useEffect(() => {
		if (isError) {
			setFakeError(isError);
			setValues(
				Number(sessionStorage.getItem('inputLength')) === 6
					? ['', '', '', '', '', '']
					: ['', '', '', '']
			);
		}
	}, [isError]);

	useEffect(() => {
		if (counter == 0) {
			setIsResendCodeActive(true);
			setCounter(Number(sessionStorage.getItem('resendIn')));
		}
		const timer =
			counter > 0 && setInterval(() => setCounter(counter - 1), 1000);
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		return () => clearInterval(timer as any);
	}, [counter]);

	return (
		<div className={'component'}>
			<div className={'innerComponent'}>
				<CustomButton
					isBack={true}
					onClick={handleBackClick}
					className={'backButton'}
				/>
				<h1 className={'confirmEmailText'}>
					{t('registrationConfirm')}
				</h1>
				<h1 className={'confirmCodeText'}>
					{t('registrationCode')} {sessionStorage.getItem('email')}
				</h1>
				<div className={'codeInputBlock'}>
					<PinInput isLoading={isPending} isError={fakeError} fields={fields} />
					{fakeError ? (
						<h1 className={'errorText'}>
							{
								(mutationError as any)?.message //eslint-disable-line @typescript-eslint/no-explicit-any
							}
						</h1>
					) : (
						<div className={'errorText'} />
					)}
					{isResendCodeActive ? (
						<h1
							className={'resendCodeText'}
							onClick={handleResendCode}
						>
							{t('registrationResend')}
						</h1>
					) : (
						<h1 className={'resendCodeText-inactive'}>
							{t('registrationResendIn')} {counter}
						</h1>
					)}
				</div>
			</div>
		</div>
	);
};

export default RegistrationEmailCodeLayout;
